import { useField as useFinalField, UseFieldConfig } from 'react-final-form'

import defaultSubscription from './defaultSubscription'
import useFieldContext from './useFieldContext'

export interface IUseFieldOption<T> extends UseFieldConfig<T> {
  subscribeAll?: boolean
  onlyValid?: boolean
  ignorePrefix?: boolean
}

const useFieldValue = <T>(
  name: string,
  options: IUseFieldOption<T> = {},
): T => {
  const {
    subscription,
    subscribeAll,
    onlyValid,
    ignorePrefix,
    ...restOptions
  } = options || {}

  const { prefix } = useFieldContext()

  let fieldName = name

  if (prefix && !ignorePrefix) {
    fieldName = `${prefix}.${fieldName}`
  }

  const field = useFinalField<T>(fieldName, {
    ...restOptions,
    subscription: subscribeAll
      ? defaultSubscription
      : subscription || { value: true, valid: !!onlyValid },
  })

  const {
    input: { value },
    meta: { valid },
  } = field

  if (onlyValid) {
    return (valid && value) as T
  }

  return value
}

export default useFieldValue
